module.exports = __webpack_public_path__ + "static/media/canallightromain.e7af0772.woff2";